'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { Link as MuiLink, Tooltip, Typography } from '@unity/cloud-ui';

export interface GlossaryTermProps {
  term: string;
  definition?: string;
  moreInfoUrl?: string;
  displayText?: string;
}

export const GlossaryTerm = (props: GlossaryTermProps) => {
  const t = useTranslations();

  if (!props.term) {
    return null;
  }

  const tooltipContent = (
    <>
      <Typography component="span" fontWeight="bold">
        {props.term}
      </Typography>
      <Typography component="p">{props.definition}</Typography>
      {props.moreInfoUrl && (
        <MuiLink component={Link} href={props.moreInfoUrl} external>
          {t('mdx:glossary-term:more-info')}
        </MuiLink>
      )}
    </>
  );

  return (
    <Tooltip arrow title={tooltipContent} placement="top">
      <Typography component="span" fontWeight="bold" sx={{ textDecoration: 'underline', width: 'max-content' }}>
        {props.displayText || props.term}
      </Typography>
    </Tooltip>
  );
};
